export default "__VITE_ASSET__CJ3ZBPJb__"